import styled from 'styled-components';

/*
  material-ui grid has negative margin. In this case margin is -4px.
  To fix layout padding is set on parent element.
*/
export const Form = styled.form`
  padding: 4px;
`;
